const FEATURES = [
  {
    icon: 'ri-flashlight-fill',
    title: '极速加载不缓冲',
    desc: '自建多线CDN智能分发网络，覆盖全国加速节点。智能路由选择最优线路，1080P高清片源加载快如闪电，告别转圈等待，专注沉浸式观影体验。',
    bg: 'bg-primary-100',
    text: 'text-primary-700',
  },
  {
    icon: 'ri-stack-fill',
    title: '海量电影大全库',
    desc: '收录超过3.2万部高清电影资源，涵盖动作、喜剧、科幻、悬疑、爱情、动画等全类型。每日更新最新片源，经典老片与新片热映一站搞定，你想看的这里都有。',
    bg: 'bg-accent-100',
    text: 'text-accent-700',
  },
  {
    icon: 'ri-smartphone-fill',
    title: '全平台无缝观影',
    desc: '完美适配电脑、平板和手机全平台。支持iOS与Android移动端，观影记录云端同步。通勤路上、午休间隙、沙发窝着，随时随地打开花生影院就能看。',
    bg: 'bg-secondary-200',
    text: 'text-secondary-800',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            为什么超过500万影迷选择花生影院？因为我们真的懂观影
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {FEATURES.map((feature, i) => (
            <div
              key={i}
              className="p-6 md:p-8 rounded-2xl bg-background-50 border border-secondary-100/60 text-center hover:border-primary-200 transition-all cursor-pointer"
            >
              <div
                className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl ${feature.bg} ${feature.text} mx-auto mb-5`}
              >
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}